<script setup lang="ts">
/* eslint-disable */
import { onMounted, computed, ref } from "vue"
import { IonApp } from '@ionic/vue';
import { Device } from "@capacitor/device";

import config from './set_config.json'
import { setSpace, backgroundMusic, updateStarsSpeed } from './helpers/renderer.js'
import { init, awardCoins } from './helpers/functions.js'
import { storage } from './storage'
import { clickDelay, upgrades, galaxies, shipLevels, shipsTypes2 } from './staticData'
import SpaceBar from './components/SpaceBar.vue'
import AliensList from "./components/AliensList.vue";
import TopPart from './components/TopPart.vue'
import TutorialWindow from './components/TutorialWindow.vue'
import UserNotification from './components/UserNotification.vue'
let clickMusic = new Audio();


const totalEarningPerSec = computed(() => {
  let earnedCoins = 0n;
  for (const [__, jelly] of Object.entries(storage.ALIENS_OWNED)) {
    if (jelly.amount > 0) {
      let earn = jelly.amountEarning()
      // let earn = 1n
      earnedCoins += earn;
    }
  }
  if (storage.BOOST_ON) earnedCoins *= BigInt(storage.BOOST_NUM)

  return earnedCoins;
})

const showTutorial = ref(false)
const tutorialStep = ref(0)
const messageDisplay = ref('none')
const topClasses = ref('')
const isMounted = ref(false)
init(totalEarningPerSec.value)
onMounted(async () => {
  setSpace()
  setAudioUrl()
  try {
    if (storage.MUSIC_ON)
      await backgroundMusic.play()
  } catch (err) { }
  clickMusic.loop = true
  if (storage.GALAXY_IND === 0 && storage.COINS === 0n) {
    activateTutorial()
  }
  if (window.innerHeight < 300) messageDisplay.value = 'flex'
  isMounted.value = true
  // setTimeout(() => {
  //   window.scrollTo(0, 1);
  // }, 0)
})


const isMobile = (toMatchItem: String) => {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];
  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

async function activateTutorial() {
  showTutorial.value = true
  const info = await Device.getInfo();
  const isMobileP = isMobile(info.model)
  if (isMobileP) {
    tutorialStep.value = 0
    document.getElementById('space-ship-wrap').addEventListener('touchstart', clickStep)
  } else {
    tutorialStep.value = 1
    document.addEventListener('keydown', spaceStep)
    document.getElementById('space-ship-wrap').addEventListener('click', spaceStep)
  }

  function clickStep() {
    document.getElementById('space-ship-wrap').removeEventListener('touchstart', clickStep)
    firstBuy()
  }

  function spaceStep(event) {
    if (event.type === 'keydown' && (event.key === ' ' || event.key === 'Spacebar') || event.type === "click") {
      event.preventDefault();
      document.removeEventListener('keydown', spaceStep)
      document.getElementById('space-ship-wrap').removeEventListener('click', spaceStep)
      firstBuy()
    }
  }

  function firstBuy() {
    showTutorial.value = false
    const interval = setInterval(() => {
      if (storage.COINS >= 25n && !showTutorial.value) {
        tutorialStep.value = 2
        showTutorial.value = true
        document.getElementById('first-buy-btn').addEventListener('click', hideTutorial)
        clearInterval(interval)
      }
    }, 1000)
  }
  function hideTutorial() {
    // console.log('HIDE TUTORIAL')
    showTutorial.value = false
    document.getElementById('first-buy-btn').removeEventListener('click', hideTutorial)
  }
}

function setAudioUrl() {
  if (clickMusic) {
    clickMusic.pause()
    clickMusic.currentTime = 0;
  }
  const audioUrl = galaxies[storage.GALAXY_IND] ? galaxies[storage.GALAXY_IND].audioUrl : galaxies[galaxies.length - 1].audioUrl
  clickMusic = new Audio(`/spacebar-clicker/assets/sounds/${audioUrl}`)

}

setInterval(() => {
  awardCoins(totalEarningPerSec.value)
  // updateNumber(storage.CLICKS_ALL * 0.005)
}, 100)

let soundTimeout = null;

function updateSound() {
  if (!storage.MUSIC_ON) return;
  if (soundTimeout) clearInterval(soundTimeout)
  if (clickMusic.paused) clickMusic.play()

  soundTimeout = setTimeout(() => {
    clickMusic.pause()
  }, clickDelay);
}

let clickTimer = null
const clickCount = ref(0)

function toCountClick() {
  storage.CLICKS_ALL += 1

  checkForShipLevel()
  clickCount.value += 1
  if (!clickTimer) clickTimer = setTimeout(() => {
    // console.log('CLICKS per second', (clickCount.value).toString())
    if (clickCount.value >= 10) storage.MAXED_SPEED += 1
    clickCount.value = 0
    clearTimeout(clickTimer)
    clickTimer = null
  }, 4000)
}
const newShipNotification = ref(null)
const shipsNum = ref(0)
for (const [_, lvl] of Object.entries(storage.SHIP_OWNED)) {
  shipsNum.value += lvl
}
function checkForShipLevel() {
  // console.log('shipsNum.value', shipsNum.value, 'storage.SHIP_OWNED', storage.SHIP_OWNED)
  if (shipsNum.value >= Object.keys(shipsTypes2).length) return;
  if (shipLevels[shipsNum.value] <= storage.CLICKS_ALL) {
    const newShipKey = newShipType()
    shipsNum.value += 1
    storage.SHIP_OWNED[newShipKey] = 1
    newShipNotification.value = 1
    // storage.CURRENT_SHIP = newShipKey
  }

}

const newShipType = () => {
  const keys = Object.keys(shipsTypes2)
  // return 'banana'
  while (true) {
    const random = Math.floor(Math.random() * (keys.length))
    if (typeof keys[random] === 'string') {
      // console.log('WHILE LOOP', random)
      const theVal = storage.SHIP_OWNED[keys[random]]
      // if (theVal === 0) return keys[random]
      if (!theVal || theVal === 0) return keys[random]
    }
  }
}
function activateBar(coins: boolean) {
  if (soundTimeout === null && storage.MUSIC_ON && backgroundMusic.paused)
    backgroundMusic.play()

  updateSound()
  if (coins) {
    toCountClick()
    addCoins()
  }
  updateStarsSpeed()

}
function addCoins() {
  let amount = 1n * BigInt(upgrades.ships.values[storage.UPGRADES_LVLS.ships])
  // console.log('AMOUNT', amount)
  if (storage.BOOST_ON) amount *= BigInt(storage.BOOST_NUM)
  storage.COINS += amount
}

function makeFullScreen() {
  const canvas = document.getElementById('general-wrap')
  canvas.scrollBy({ top: 2 })
  if (canvas.requestFullscreen) canvas.requestFullscreen();
  else if (canvas.webkitRequestFullscreen) canvas.webkitRequestFullscreen();
  else if (canvas.mozRequestFullScreen) canvas.mozRequestFullScreen();
  else if (canvas.msRequestFullscreen) canvas.msRequestFullscreen();
  else if (canvas.webkitEnterFullscreen) canvas.webkitEnterFullscreen();

  messageDisplay.value = 'none'
}
//ADDDDDDDS

async function adFinished() {
  storage.ADD_ON = false
  if (storage.MUSIC_ON) {
    try {
      await backgroundMusic.play()
    } catch (err) {
      console.log('adFinished', err)
    }
  }
}
function adStarted() {
  storage.ADD_ON = true
  if (storage.MUSIC_ON) backgroundMusic.pause()
}

function launchAnAd() {
  console.log("DEBUG launchAnAd is called")

  if (typeof gdsdk !== 'undefined' && gdsdk?.preloadAd !== undefined) {
    gdsdk.showAd();
  }
}

setInterval(() => {
  launchAnAd();
}, 1000 * 60 * 5)


const activateBoost = ref(false)
function activateGameBoost() {
  console.log("DEBUG activation boost is called")
  if (gdsdk?.preloadAd !== undefined) {
    gdsdk.preloadAd('rewarded')
      .then(() => console.log('AD is ready after AD'))
      .catch(() => null);
  }
  // storage.BOOST_ON = true
  console.log("DEBUG activateBoost is called")
  activateBoost.value = true
  setTimeout(() => {
    activateBoost.value = false
  }, 1500)
}

if (!config.isDev) {
  window["GD_OPTIONS"] = {
    "gameId": "48c1c73ea3824b278232b514ca858f3a",
    "onEvent": function (event: any) {
      console.log("DEBUG: GD Event", event)
      switch (event.name) {
        case "AD_ERROR":
          // if (event.message === 'Promo not found') clearInterval(awardInterval)
          console.log("DEBUG", event.message)
          break;
        case "SDK_ERROR":
          console.log('event', event)
          break;
        case "SDK_READY":
          console.log('WE ready')
          if (typeof gdsdk !== 'undefined' && typeof gdsdk.preloadAd !== 'undefined') {
            gdsdk.preloadAd('rewarded')
              .then(() => {
                console.log('AD is ready')
                // launchAnAd()
              })
              .catch(() => null);
          }
          break;
        case "SDK_GAME_START":
          // advertisement done, resume game logic and unmute audio
          adFinished();
          break;
        case "ALL_ADS_COMPLETED":
        case "SDK_REWARDED_WATCH_COMPLETE":
          activateGameBoost()
          break;
        case "SDK_GAME_PAUSE":
          adStarted();
          break;
        case "SDK_GDPR_TRACKING":
          // this event is triggered when your user doesn't want to be tracked
          break;
        case "SDK_GDPR_TARGETING":
          // this event is triggered when your user doesn't want personalised targeting of ads and such
          break;
        case "SDK_REWARDED_WATCH_COMPLETE":
          break;
        default:
        // console.log('NOT CATCH', event)
      }
    },
  };

  (function (d, s, id) {
    try {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s);
      js.id = id;
      js.src = 'https://html5.api.gamedistribution.com/main.min.js';
      fjs.parentNode.insertBefore(js, fjs);
    } catch (e) {

    }
  }(document, 'script', 'gamedistribution-jssdk'));

}
</script>

<template>
  <ion-app>

    <div class="game-wrap">
      <div id="general-wrap">
        <TopPart :earningsPerS="totalEarningPerSec" 
        v-if="isMounted"
        :shipsNum="shipsNum" 
        :topClasses="topClasses"
        :activateBoost="activateBoost"
        @set-new-audio="setAudioUrl" 
        @show-notification="(num: number) => newShipNotification = num" />
        <div id="space" v-pre />
        <SpaceBar @space-mouse-click="activateBar" :aliens="storage.CLICKS_ALL" />
        <AliensList :marginClass="topClasses" />
        <TutorialWindow v-show="showTutorial" :curStep="tutorialStep" @hide-window="showTutorial = false" />
        <UserNotification v-if="newShipNotification" :type="newShipNotification" @hide-window="newShipNotification = null" />

        
        <div id="full-screen" :style="{ 'display': messageDisplay }" @click="makeFullScreen">
          <p >Enter full screen</p>
        </div>
      </div>
    </div>
    <div id="warning-message">
      <h1>Please rotate your device to landscape mode to start playing.</h1>
      <br>
      <img width="300" src="/spacebar-clicker/assets/pics/rotate.png" alt="">
    </div>
  </ion-app>
  </template>
<style>
* {
  color: #FFFFFF;
  margin: 0;
  padding: 0;
  overflow: hidden;
  user-select: none;
  scroll-behavior: auto;
}

.game-wrap {
  /* background-color: #FFFFFF; */
  overflow: scroll;
  /* scroll-behavior: auto; */
}

/* .game-wrap {
  background-color: #FFFFFF;
  overflow: scroll;
  scroll-behavior: auto;
}

#general-wrap {
  background-color: #FFFFFF;
  overflow: scroll;
  scroll-behavior: auto;
} */

/* ion-content {
  --background: #000;
} */

#full-screen {
  position: fixed;
  top: 0;
  left: 0;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: hsla(0, 0%, 0%, 0.5);
  color: white;
  text-align: center;
  align-items: center;
  height: 100dvh;
  width: 100vw;
  margin: auto;
}

#full-screen p {
  font-size: 2rem;
  padding: 1rem;
  color: white;
}


.btn-action {
  width: fit-content;
  color: rgb(222, 211, 211);
  background-color: rgb(139, 12, 12);
  border-radius: 20px;
  padding: 5px 10px;
  font-size: 16px;
}


.action-btn {
  padding: 0.625rem 0.93rem;
  color: black;
  background-color: greenyellow;
  border-radius: 20px;
  font-size: 1rem;
}

.action-btn:disabled {
  filter: brightness(0.7);
}

.action-btn:disabled:hover {
  cursor: default;
}

img.coin-sm {
  height: 1.25rem;
}

button:disabled {
  filter: brightness(0.6);
}

button:disabled:hover {
  cursor: default;
}

.action-btn.disabled {
  filter: brightness(0.6);
}

.action-btn.disabled:hover {
  cursor: default;
}

.user-msg {
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 100;
  padding: 20px;
  transform: translate(-50%, -50%);
  font-size: 2rem;
  background-color: rgba(0, 0, 0, 0.717);
  color: aliceblue;
  border-radius: 20px;
}

.active-link:hover {
  cursor: pointer;
}

.column-list {
  height: fit-content;
  width: fit-content;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding-right: 10px;
}

.cols-wrap {
  width: 100%;
  height: 180px;
  /* height: fit-content; */
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 5px;
  padding: 5px 10px;
  border: 2px solid yellow;
  border-radius: 20px;
  position: relative;
}

.cols-wrap>div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: fit-content;
  position: relative;
}

.row {
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: visible;
  align-items: center;
  justify-content: space-between;
}

.col {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.aura-on {
  box-shadow: 0px 0px 17px 10px rgba(255, 0, 0, 0.68);
  animation: heartOn 1s infinite alternate;
}

#warning-message {
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: white;
  text-align: center;
  align-items: center;
  height: 100dvh;
  width: 100vw;
  margin: auto;
}

.to-center {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

/* html.ios body {
  height: 100.1%;
} */

@keyframes heartOn {
  to {
    box-shadow: 0px 0px 17px 20px rgba(255, 0, 0, 0.68);
    /* transform: scale(1.4); */
  }
}

@media (max-width: 1000px) {
  * {
    font-size: 12px;
  }

  .cols-wrap {
    max-height: 10.5rem;
    position: relative;
  }
}

@media (orientation:portrait) and (max-width: 1000px) {
  .game-wrap {
    opacity: 0 !important;
  }

  #warning-message {
    display: flex;
  }
}

/* @media (min-width: 1000px) and (orientation:landscape) {
  #warning-message {
    display: none;
  }
} */
</style>